<div class="file-upload-container">
    <p class="file-upload--label">
        {{labelText}}
    </p>

    <div class="file-group--container "*ngIf="isImg && filesImg.length > 0">
        <div class="file-upload-view--container" *ngFor="let img of filesImg; let i = index" >
            <div  *ngIf="img.src  && img.src !== ''"  class="file-upload-view--contain">
                <a target="_blank" [href]="img.src" class="file-thumbaline-view">
                    <div *ngIf="img.type == 'application/pdf'" class="file-upload-view file-pdf" > </div>
                    <img *ngIf="img.type != 'application/pdf'" class="file-upload-view" [src]="img.src" [alt]="'archivo' + i"> 
                </a>
                    <mat-icon (keydown)="deleteImg(i)" (click)="deleteImg(i)" class="file-upload-view-icon" >
                        delete
                    </mat-icon>
            </div>
        </div>
    </div>
    <div *ngIf="!isImg && filesImg.length > 0">
        <div class="file-upload-document--contain" *ngFor="let file of filesImg; let i = index">
            <p class="file-upload-view--document"  >
                {{file?.name}}
            </p>
            <mat-icon (keydown)="deleteImg(i)" (click)="deleteImg(i)" >
                delete
            </mat-icon>
        </div>
    </div>

    <input #fileInput accept="image/*,application/pdf" [attr.capture]="useCamera ? 'camera' : null"
    [disabled]="oneFile && filesImg.length == 1" type="file" class="input-file" [id]="id" (change)="onFileSelected($event)">
    <div *ngIf="!oneFile || oneFile && filesImg.length < 1" class="file-upload" appDrag (files)="onFileDropped($event)"  (keydown)="openFileDialogOnKeyDown($event)" (click)="openFileDialog()" >
        <div class="file-upload--content">
            <p *ngIf="!oneFile || oneFile && filesImg.length < 1" class="file-upload--extension">
                Extensiones: {{extensionsText}} / Max Size: {{maxSizeFile}} Mb
            </p >
            <div class="file-upload--drop" >
                <span >
                     Para adjuntar haga click o arrastre aquí el o los archivos
                </span>
            </div>
        </div>
    </div>

    <label class="warning-label" *ngIf="validateWarning()">Debe adjuntar este archivo</label>
</div>


